import React from 'react';
import {FlyoutProps} from '../Flyout/Flyout';
import {DropDownProps} from '../Dropdown/Dropdown';
import {ModalDialogProps} from '../ModalDialog/ModalDialog';
import {DrawerProps} from '../Drawer/Drawer';

export type ContentPopperBaseProps = {
  // content nodes
  openerContent?: React.ReactNode;
  headerContent?: React.ReactNode;
  bodyContent?: React.ReactNode;

  onClose: () => void;
  onOpenerClick?: () => void;

  open: boolean;
  isActive?: boolean;
  showHeaderDivider?: boolean;
  className?: string;
  dataTestId?: string;
  /**
   * Only applicable for modal and flyout
   */
  renderInPortal?: boolean;
  /**
   * Only applicable for drawer
   */
  slideDirection?: 'left' | 'right';
  /**
   * Only applicable for modal
   */
  showCloseIcon?: boolean;
  fixedSmallWidth?: boolean;
  preventSlideUpAnimation?: boolean;
};

export interface ContentPopperProps extends ContentPopperBaseProps {
  LayoutComponent:
    | React.FC<FlyoutProps>
    | React.FC<DropDownProps>
    | React.FC<ModalDialogProps>
    | React.FC<DrawerProps>;
}

export const ContentPopper: React.FC<ContentPopperProps> = ({
  LayoutComponent,
  ...props
}) => <LayoutComponent {...props} />;
